module.exports = __webpack_public_path__ + "img/deafinition_logo.ee6cb3a0.png";